import React, { useEffect, useState } from "react";
import { collection, query, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { doc, deleteDoc } from "firebase/firestore";
import { Link } from "react-router-dom";

const TeachersField = () => {
  const [list, setList] = useState([]);

  const deleteTech = async (tid) => {
    await deleteDoc(doc(db, "techList", tid));
    console.log("Deleted ===>" + tid);
  };

  useEffect(() => {
    const q = query(collection(db, "techList"));
    onSnapshot(q, (querySnapshot) => {
      let teacherArray = [];
      querySnapshot.forEach((doc) => {
        teacherArray.push({ id: doc.id, ...doc.data() });
      });
      setList(teacherArray);
    });
  }, []);

  return (
    <div className="p-5">
      <h1 className="text-left mb-4 ml-2 text-3xl font-semibold">
        Teachers List
      </h1>
      <table className="w-full border text-center">
        <thead className="border-b ">
          <tr className="bg-gray-100">
            <th className="py-3"> Sl No.</th>
            <th className="py-3"> First Name</th>
            <th className="py-3">Middle Name</th>
            <th className="py-3"> Last Name</th>
            <th className="py-3">User Id</th>
            <th className="py-3"> Email Id</th>
            <th className="py-3">Teaching Subject</th>
            <th className="py-3 ">Delete</th>
            <th className="py-3 ">Update</th>
          </tr>
        </thead>
        <tbody>
          {list?.map((item, index) => (
            <tr className="border-b" key={index}>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {++index}
              </td>

              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.firstName}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.middleName}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.lastName}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.userId}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.emailId}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.teachingSubject}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                <button
                  className="text-white bg-red-600 py-1 px-1 rounded-md "
                  onClick={() => deleteTech(item.id)}
                >
                  Delete
                </button>
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                <Link to={"../updateTeacher"} state={{ teacherId: item.id }}>
                  <button className="text-white bg-green-600 py-1 px-1 rounded-md">
                    Update
                  </button>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TeachersField;
